import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage, injectIntl } from 'react-intl';
// import _get from 'lodash/get';
// import _compact from 'lodash/compact';

import AppLink from '../AppLink';
import ToggleArrow from '../ToggleArrow';
import Collapse from '../Collapse';
import OrderItemDescriptionView from './OrderItemDescriptionView';

import styles from './OrderItemDescription.styl';

const cx = classNames.bind(styles);

class OrderItemDescription extends Component {
  state = {
    compositionIsOpen: false,
  };

  toggleComboComposition = e => {
    e.preventDefault();
    this.setState({ compositionIsOpen: !this.state.compositionIsOpen });
  };

  render() {
    const { className, composition, view } = this.props;
    const { compositionIsOpen } = this.state;

    return (
      <React.Fragment>
        <Collapse isOpen={this.state.compositionIsOpen}>
          <div
            className={cx('OrderItemDescription__composition')}
            onClick={this.toggleComboComposition}>
            {composition.map(good => (
              <OrderItemDescriptionView
                key={good.hash}
                view={view}
                className={className}
                {...good}
              />
            ))}
          </div>
        </Collapse>
        <div className={cx('OrderItemDescription__compositionToggleWrapper')}>
          <AppLink
            href="#"
            className={cx('OrderItemDescription__compositionToggle')}
            onClick={this.toggleComboComposition}>
            <FormattedMessage
              id={compositionIsOpen ? 'cart.composition.rollUp' : 'cart.composition.more'}
            />
            <ToggleArrow
              className={cx('OrderItemDescription__compositionToggleArrow')}
              isOpen={compositionIsOpen}
            />
          </AppLink>
        </div>
      </React.Fragment>
    );
  }
}

OrderItemDescription.defaultProps = {
  className: '',
  view: 'compact',
};

OrderItemDescription.propTypes = {
  className: PropTypes.string,
  composition: PropTypes.array,
  view: PropTypes.string,
  intl: PropTypes.object,
};

export default injectIntl(OrderItemDescription);

//

// getSize = good => {
//   const sizeValue = _get(good, 'size.value', '');
//   const sizeUnit = _get(good, 'size.unit', '');

//   if (sizeValue && sizeUnit) {
//     return `${sizeValue}&nbsp;${sizeUnit}`;
//   }

//   return false;
// };

// renderComboboxDescription = () => {
//   const { intl, ...good } = this.props;
//   const composition = _get(good, 'item.combo_box_items');
//   const descriptions = composition.map((good, index) => {
//     const name = _get(good, 'custom_name', '') || _get(good, 'name', '');
//     const size = this.getSize(good);
//     const count = good.count > 1 ? `(${good.count})` : '';
//     let productDescription = _compact([name, size, count]).join(' ');
//     if (good.stuffed_crust && good.stuffed_crust !== 'none') {
//       productDescription += ' + ';
//       productDescription += intl
//         .formatMessage({
//           id: `pizza.stuffedCrust.${good.stuffed_crust}`,
//         })
//         .toLowerCase();
//     }
//     return `${productDescription}${composition.length - 1 !== index ? ',' : ''}`;
//   });
//   return <span dangerouslySetInnerHTML={{ __html: descriptions.join(' ') }} />;
// };
